"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.XResolveError = void 0;
var tslib_1 = require("tslib");
/**
 * An error thrown by the XResolve EndpointsProvider function.
 */
var XResolveError = /** @class */ (function (_super) {
    tslib_1.__extends(XResolveError, _super);
    function XResolveError(code, message, status) {
        if (status === void 0) { status = -1; }
        var _this = _super.call(this, message) || this;
        _this.name = 'XResolveError';
        _this.message = message;
        _this.code = code;
        _this.status = status;
        return _this;
    }
    return XResolveError;
}(Error));
exports.XResolveError = XResolveError;
//# sourceMappingURL=xresolve.js.map